<template>
  <footer>
    <div class="svg-container">
      <a href="https://www.facebook.com/groups/234068009999344" target="_blank">
        <img src="../assets/svg/facebook.svg" />
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
}
</script>

<style lang="scss" scoped>
footer {
  // display: flex;
  // flex-direction: row;
  // justify-content: space-around;
  padding-top: 10px;
  height: 50px;
  line-height: 2vh;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.svg-container {
  height: 20px;
  
  img {
    max-height: 100%;
  }
}
</style>
